module.exports = __webpack_public_path__ + "img/qrcode.65423ef6.jpg";